import { render, staticRenderFns } from "./detailsFiche.vue?vue&type=template&id=5e4eedf2&scoped=true"
import script from "./detailsFiche.vue?vue&type=script&lang=js"
export * from "./detailsFiche.vue?vue&type=script&lang=js"
import style0 from "./detailsFiche.vue?vue&type=style&index=0&id=5e4eedf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4eedf2",
  null
  
)

export default component.exports